import React from "react";
import { useTranslation } from "react-i18next";
import { FilterX, SendHorizonal } from "lucide-react";
import CustomDropdown from "../../../Components/admin/CustomDropdown";

const TeacherFilters = ({
  searchQuery,
  setSearchQuery,
  campusIdValue,
  classIdValue,
  sectionIdValue,
  campuses,
  campusClassesDetail,
  uploadType,
  handleUploadTypeChange,
  setIsNotificationsModal,
  dispatch,
  setCampusId,
  setClassId,
  setSectionId,
  resetFilters,
}) => {
  const { t } = useTranslation();

  // Get unique campus, class, and section IDs/names for filters
  const uniqueCampuses = campuses?.map((campus) => ({
    id: campus.id,
    name: campus.name,
  })) || [];

  const uniqueClasses = campusClassesDetail?.flatMap((campus) =>
    campus.classes?.map((cls) => ({
      id: cls.id,
      name: cls.className,
      campusId: campus.id,
    }))
  ) || [];

  const uniqueSections = campusClassesDetail?.flatMap((campus) =>
    campus.classes?.flatMap((cls) =>
      cls.sections?.map((section) => ({
        id: section.id,
        name: section.sectionName,
        classId: cls.id,
      }))
    )
  ) || [];

  // Filter classes based on selected campus
  const filteredClasses = campusIdValue
    ? uniqueClasses.filter((cls) => cls.campusId === campusIdValue)
    : uniqueClasses;

  // Filter sections based on selected class
  const filteredSections = classIdValue
    ? uniqueSections.filter((section) => section.classId === classIdValue)
    : uniqueSections;

  // Handle campus filter change
  const handleCampusChange = (value) => {
    dispatch(setCampusId(value));
    dispatch(setClassId(""));
    dispatch(setSectionId(""));
  };

  // Handle class filter change
  const handleClassChange = (value) => {
    dispatch(setClassId(value));
    dispatch(setSectionId(""));
  };

  // Handle section filter change
  const handleSectionChange = (value) => {
    dispatch(setSectionId(value));
  };

  return (
    <div className="mb-4 flex gap-4">
      <div className="flex flex-grow items-end lg:col-span-2">
        <input
          type="text"
          placeholder={t("SearchByNameOrId")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full p-2 border rounded"
        />
      </div>

      <div>
        <CustomDropdown
          options={uniqueCampuses.map((campus) => campus.name)}
          value={campusIdValue ? uniqueCampuses.find((c) => c.id === campusIdValue)?.name : ""}
          onChange={(value) => {
            const campus = uniqueCampuses.find((c) => c.name === value);
            handleCampusChange(campus ? campus.id : "");
          }}
          placeholder={t("AllCampuses")}
        />
      </div>

      <div>
        <CustomDropdown
          options={filteredClasses.map((cls) => cls.name)}
          value={classIdValue ? filteredClasses.find((c) => c.id === classIdValue)?.name : ""}
          onChange={(value) => {
            const cls = filteredClasses.find((c) => c.name === value);
            handleClassChange(cls ? cls.id : "");
          }}
          placeholder={t("AllClasses")}
        />
      </div>

      {classIdValue && (
        <div>
          <CustomDropdown
            options={filteredSections.map((section) => section.name)}
            value={sectionIdValue ? filteredSections.find((s) => s.id === sectionIdValue)?.name : ""}
            onChange={(value) => {
              const section = filteredSections.find((s) => s.name === value);
              handleSectionChange(section ? section.id : "");
            }}
            placeholder={t("AllSections")}
          />
        </div>
      )}

      <div>
        <button
          className="p-2 bg-gray-200 rounded flex items-center gap-2 cursor-pointer hover:bg-gray-300"
          onClick={() => dispatch(resetFilters())}
        >
          <FilterX size={18} />
          <span>{t("ClearFilters")}</span>
        </button>
      </div>

      <div className="sm:flex-[1_1_0%]">
        <select
          className="w-full bg-[#241763] text-white p-2 rounded"
          onChange={(e) => handleUploadTypeChange(e.target.value)}
          value={uploadType}
        >
          <option value="" disabled>
            {t("AddTeacher")}
          </option>
          <option value="single">{t("AddTeacher")}</option>
          <option value="bulk">{t("BulkUploadTeacher")}</option>
        </select>
      </div>

      <div
        className="bg-[#241763] p-2 rounded"
        onClick={() => setIsNotificationsModal(true)}
      >
        <SendHorizonal className="text-white w-6 h-6 group-hover:text-white" />
      </div>
    </div>
  );
};

export default TeacherFilters; 